// store/slices/frequencySlice.js - Frequency settings and sweep state slice

import { SignalChainCalculator } from '../../utils/signalChainCalculator';

export const createFrequencySlice = (set, get) => ({
  // State
  frequencyMode: 'single', // 'single' or 'sweep'
  frequencySingle: 1700, // MHz
  frequencyStart: 1, // MHz
  frequencyStop: 6000, // MHz
  frequencyStep: 50, // MHz increment (default for 6000MHz range)
  sweepResults: null,
  isSweeping: false, // True while sweep calculation is in progress

  // Actions
  setFrequencyMode: (mode) => {
    const prevMode = get().frequencyMode;
    set({ frequencyMode: mode });

    // Clear sweep results when switching to single mode
    if (mode === 'single' && prevMode === 'sweep') {
      set({ sweepResults: null });
    }

    // Auto-run sweep when switching to sweep mode
    if (mode === 'sweep' && prevMode === 'single') {
      // Use setTimeout to allow state update to complete first
      setTimeout(() => get().runFrequencySweep(), 0);
    }
  },

  setFrequencySingle: (freq) => {
    set({ frequencySingle: freq });
    get().recalculateChain();
  },

  setFrequencySweepParams: (params) => {
    set((state) => {
      const newStart = params.start ?? state.frequencyStart;
      const newStop = params.stop ?? state.frequencyStop;
      const range = newStop - newStart;

      // Auto-calculate step when start/stop change (not when step is explicitly set)
      let newStep = state.frequencyStep;
      if ((params.start !== undefined || params.stop !== undefined) && params.step === undefined) {
        newStep = range > 2000 ? 50 : 10;
      } else if (params.step !== undefined) {
        newStep = params.step;
      }

      return {
        frequencyStart: newStart,
        frequencyStop: newStop,
        frequencyStep: newStep
      };
    });
    // Trigger sweep recalculation after state update
    get().runFrequencySweep();
  },

  runFrequencySweep: () => {
    const { nodes, edges, frequencyStart, frequencyStop, frequencyStep } = get();

    set({ isSweeping: true });

    // Calculate number of points from step size
    const numPoints = Math.floor((frequencyStop - frequencyStart) / frequencyStep) + 1;

    try {
      const calculator = new SignalChainCalculator(nodes, edges);
      const results = calculator.performFrequencySweep(
        frequencyStart,
        frequencyStop,
        numPoints
      );
      set({ sweepResults: results, isSweeping: false });
    } catch (error) {
      console.error('Frequency sweep error:', error);
      set({ sweepResults: null, isSweeping: false });
    }
  },
});
